<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
            	<div class="col-12 mt-4 mb-4 redeem-voucher">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <img class="img-fluid" v-bind:src="'/img/logo-white.png'"  width="150" alt="Gifted PH" title="Gifted PH" />
                                </div>
                                <div class="col-md-6">
                                    <h1 class="title">Gift Card</h1>
                                </div>

                            </div>
                        </div>
                        <div class="card card-title">
                            <h3>Claim Your Gift</h3>

                        </div>
                        <div class="card-body">
                            <table width="100%" class="table table-bordered">
                                <tbody>
                                    <tr v-if="is_for_review == 0">
                                        <td style="vertical-align: middle;"><strong>Status:</strong></td>
                                        <td v-if="is_redeemed == 0">
                                        	Available
                                        </td>
                                        <td v-if="is_redeemed == 1">
                                            Redeemed
                                        </td>
                                    </tr>
                                    <tr v-if="is_for_review == 1">
                                        <td style="vertical-align: middle;"><strong>Status:</strong></td>
                                        <td>
                                            For Verification
                                        </td>

                                    </tr>

                                    <tr>
                                        <td style="vertical-align: middle;"><strong>Date Purchased:</strong></td>
                                        <td>{{ this.ordered_on | moment }}</td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: middle;"><strong>Order #:</strong></td>
                                        <td>{{ this.order_number }}</td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: middle;"><strong>Amount:</strong></td>
                                        <td>&#8369;{{ this.amount }}</td>
                                    </tr>
                                   
                                    <tr v-if="is_redeemed == 0">
                                        <td colspan="2" style="border: 0;">
                                            <button id="upgradeBtn" class="btn btn-redeem" @click="upgrade(order_number, recipient_email)"> <i class="fa fa-coins"></i> Add to Gifted Wallet</button>
                                            <p style="text-align: center; color: #999; margin-top: 5px; line-height: 15px; padding: 0 5px;">Add the amount to your Gifted Wallet if you wish to choose multiple brands or select other brands that have extra service charge.</p>
                                        </td>
                                    </tr>
                                    

                                    <tr v-if="is_for_review == 0 && is_redeemed == 1">
                                        <td colspan="2" class="text-center">
                                            <div v-if="is_redeemed_via == 0" class="alert alert-info" style="margin-bottom: 10px;">
                                                You may have redeemed this recently . Please click Select Brands Now to view your balance and select your brands.
                                            </div>

                                            <div v-if="is_redeemed_via == 1">
                                                <a class="btn-select-brand" v-bind:href="this.select_brands_link + '#redeem'">Select Brands Now</a>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr v-if="is_for_review == 1">
                                        <td colspan="2" class="text-center">
                                            <div class="alert alert-info" style="margin-bottom: 10px; text-align: center;">
                                                Your gift card redemption is undergoing verification. We will email you once your balance is ready within one working day. Please contact <a href="mailto:admin@gifted.ph">admin@gifted.ph</a> for any further inquiries.
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .swal2-select{
        margin: 0 auto;
        width: 100%;
        max-width: 265px;
        border-radius: 5px;
        -moz-appearance:none; /* Firefox */
        -webkit-appearance:none; /* Safari and Chrome */
        appearance:none;
        background: url('/img/dropdown-arrow.png') no-repeat right center;
        background-size: contain;
    }
    .swal2-select:focus{
        border: 1px solid #DE3C4C;
        outline: none;
    }
    .swal2-validation-message{
        background-color: transparent;
    }

    @media only screen and (max-width: 767px) {
        .swal2-title {
            font-size: 22px;
        }
    }

</style>
<style scoped>
    .redeem-voucher{
        max-width: 500px;
        margin: 0 auto;
    }
    .redeem-voucher .card-header{
        background-color: #DE3C4C;
    }
    .redeem-voucher .card-header .title{
        font-size: 30px;
        color: #fff;
        text-align: right;
        margin: 0 auto;
        padding: 8px 0;

    }
    .redeem-voucher .card-title{
        border: 0;
        margin: 0;
    }
    .redeem-voucher .card-title h3{
        text-align: center;
        padding: 15px;
        background-color: #eee;
        margin: 0;
    }
    .redeem-voucher table{
        margin: 0;
    }
    .redeem-voucher table tr:first-child td{
        border-top: 0;
    }
    .redeem-voucher button.btn-redeem{
        width: 100%;
        background-color: #DE3C4C;
        color: #fff;
        font-size: 20px;
        outline: 0;
        border: 0;
    }
    .redeem-voucher button.btn-redeem:hover, .redeem-voucher button.btn-redeem:focus{
        outline: 0;
        border: 0;
    }
    .btn-select-brand{
        display: block;
        color: rgb(255, 255, 255);
        background-color: rgb(222, 60, 76);
        border: 1px solid rgb(222, 60, 76);
        border-radius: 5px;
        cursor: pointer;
        text-decoration: none;
        font-size: 16px;
        font-weight: bold;
        padding: 6px 25px;
        text-transform: capitalize;
        width: 100%;
        max-width: 250px;
        margin: 0 auto;
    }

    
</style>
<script>
    import moment from 'moment'

    export default {
        props: ['order', 'products', 'redeemed', 'for_review', 'redeemed_via', 'system_email', 'page_link'],
        data(){
            return {
                order_number: "",
                ordered_on: "",
                status: "",
                amount: "",
                recipient_email: "",
                available_products: "",
                is_redeemed: "",
                is_for_review: "",
                is_redeemed_via: "",
                is_system_email: "",
                select_brands_link: "",
            }
        },
        mounted() {
    
            const order = JSON.parse(this.order)
            this.order_number = order.order_number;
            this.ordered_on = order.ordered_on;
            this.status = order.status;
            this.amount = order.subtotal;
            this.recipient_email = order.recipient_email;

            const products = JSON.parse(this.products)
            this.available_products = products;
            //console.log(products);
            
            const redeemed = JSON.parse(this.redeemed)
            this.is_redeemed = redeemed;
            //console.log(redeemed);

            const page_link = JSON.parse(this.page_link)
            this.select_brands_link = page_link;
            //console.log(redeemed);

            const for_review = JSON.parse(this.for_review)
            this.is_for_review = for_review;
            //console.log(for_review);

            const redeemed_via = JSON.parse(this.redeemed_via)
            this.is_redeemed_via = redeemed_via;
            
            const system_email = JSON.parse(this.system_email)
            this.is_system_email = system_email;

            if(system_email == 1){
                //this.check_system_email(this.order_number)
            }

        },
        methods: {
            check_system_email: function (orderNumber) {

                var recipientEmail;
                var recipientFirstname;
                var recipientLastname;

                Swal.mixin({
                  input: 'text',
                  backdrop: '#c6e3de',
                  confirmButtonText: 'Next &rarr;',
                  showCancelButton: true,
                  confirmButtonColor: '#DE3C4C',
                  cancelButtonColor: '#ccc',
                  progressSteps: ['1', '2', '3'],
                  allowOutsideClick: false,
                  allowEscapeKey: false
                }).queue([
                    {
                        title: 'Your Email Address',
                        preConfirm: function(value)
                        {
                            recipientEmail= value;
                            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                            if(value == ''){
                                Swal.showValidationMessage(
                                      `Email is required.`
                                    )
                            }else if (!re.test(value)){
                                Swal.showValidationMessage(
                                      `Valid email required.`
                                    )
                            }
                        }
                    },
                    {
                        title: 'Your First Name',
                        preConfirm: function(value)
                        {
                            recipientFirstname= value;
                            if(value == ''){
                                Swal.showValidationMessage(
                                      `First Name is required.`
                                    )
                            }
                        }
                    },
                    {
                        title: 'Your Last Name',
                        preConfirm: function(value)
                        {
                            recipientLastname= value;
                            if(value == ''){
                                Swal.showValidationMessage(
                                      `Last Name is required.`
                                    )
                            }
                        }
                    }
                ]).then((result) => {
                  if (result.value) {
                    const answers = JSON.stringify(result.value)
                    Swal.fire({
                        title: 'Recipient Details',
                        html:
                            '<h4>Email: ' + recipientEmail+
                            '</h4><h4>First Name: ' + recipientFirstname+
                            '</h4><h4>Last Name: ' + recipientLastname+
                            '</h4>',
                        confirmButtonColor: '#DE3C4C',
                        confirmButtonText: 'Confirm'
                    }).then((result) => {
                      if (result.isConfirmed) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Please wait!',
                            html: 'Saving your information...',
                            showConfirmButton: false,
                        });

                        $.ajax({
                            type: "POST",
                            url: "/api/ggc_update_order",
                            data: { 'orderNumber': orderNumber, 'recipientEmail': recipientEmail, 'recipientFirstname': recipientFirstname, 'recipientLastname': recipientLastname },
                            cache: false,
                        })
                        .then(response => {
                            console.log(response);
                            //return response;
                            const result = JSON.parse(response);

                            if(result.response.class == "success"){    
                                Swal.fire({
                                  icon: result.response.class,
                                  title: result.response.message,
                                  html: '',
                                  confirmButtonColor: '#DE3C4C',
                                  confirmButtonText: 'Close'
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        location.reload();
                                    }
                                });
                            }else{
                                Swal.fire({
                                  icon: result.response.class,
                                  title: result.response.message,
                                  html: '',
                                  showConfirmButton: false,
                                })
                            }
                        })
                        .catch(error => {
                            Swal.showValidationMessage(
                              `Request failed! Please contact support.`
                            )
                        })
                      }
                    })
                  }
                });

            },
            redeem: function (orderNumber, products, is_system_email) {
                var email = this.recipient_email;

                if(this.is_system_email == 1){
                    this.check_system_email(orderNumber);
                }else{

                    if(email != 'system@gifted.ph'){
                        
                        Swal.fire({
                            //title: 'Verify Your Redemption',
                            showCancelButton: true,
                            confirmButtonText: 'Submit',
                            confirmButtonColor: '#DE3C4C',
                            showLoaderOnConfirm: true,
                            background: '#fff',
                            backdrop: 'rgb(198, 227, 222)',
                            //input: 'text',
                            html: '<h3>Verify Your Redemption</h3><p>Click on Send PIN to send a One Time PIN to your email address to confirm your redemption</p><div class="input-group mb-0">'+
                                  '<div class="input-group-prepend">'+
                                  '  <button id="resendOTP" data-email="'+email+'" data-source="Order #:'+this.order_number+'" class="btn btn-secondary" type="button" style="width: 130px;"><span id="btn-text">Send PIN</span> <span id="timer"></span></button>'+
                                  '</div>'+
                                  '<input type="text" id="swal-input2-otp" class="form-control swal2-input" placeholder="Enter PIN" style="margin: 0;">'+
                                  '</div>'+
                                  '<p style="margin-top: 15px;">Click <a onclick="$(\'#resendOTP\').trigger(\'click\')" href="javascript:;">here</a> to resend the PIN to your email</p>'+
                                  '<div id="otp-message"></div>',
                            footer: '<p style="text-align: center;">For any inquiries, please email us at admin@gifted.ph</p>',
                            preConfirm: (isConfirm) => {

                                if (!isConfirm) return;

                                var otp = document.getElementById('swal-input2-otp').value;
                                if (otp != '') {
                                    
                                    return $.ajax({
                                        type: "POST",
                                        url: "/api/validate_otp",
                                        data: { 'email': email, 'otp': otp, 'orderNumber': this.order_number },
                                        cache: false,
                                    })
                                    .then(response => {

                                        //console.log(response);
                                        const is_validate_otp = JSON.parse(response);
                                        if(is_validate_otp.response.class == "success"){

                                            var productOptions = new Promise(function (resolve) {
                                              setTimeout(function () {
                                                resolve(products)
                                              }, 500)
                                            })
                                            var productID;

                                            Swal.fire({
                                                title: 'Products Available',
                                                showCancelButton: true,
                                                confirmButtonText: 'Claim',
                                                confirmButtonColor: '#DE3C4C',
                                                showLoaderOnConfirm: true,
                                                input: 'select',
                                                inputOptions: productOptions,
                                                background: '#fff',
                                                backdrop: '#c6e3de',
                                                footer: '<p>To select more brands, <a onclick="$(\'#upgradeBtn\').trigger(\'click\')" href="javascript:;">click here</a> to add to wallet</p>',
                                                customClass: {
                                                    input: 'brand-option',
                                                },
                                                preConfirm: (productID) => {

                                                    if(productID != 0){
                                                        
                                                        Swal.fire({
                                                          icon: 'warning',
                                                          title: 'Please wait!',
                                                          html: 'Your voucher is processing...',
                                                          showConfirmButton: false,
                                                        })

                                                        $.ajax({
                                                            type: "POST",
                                                            url: "/api/ggc_redeem",
                                                            data: { 'orderNumber': orderNumber, 'productID': productID},
                                                            cache: false,
                                                        })
                                                        .then(response => {
                                                            console.log(response);
                                                            //return response;
                                                            const result = JSON.parse(response);
                                                            Swal.fire({
                                                              icon: result.response.class,
                                                              title: result.response.message,
                                                              html: '',
                                                              confirmButtonColor: '#DE3C4C',
                                                              confirmButtonText: 'Close'
                                                            }).then((result) => {
                                                                if (result.isConfirmed) {
                                                                    location.reload();
                                                                }
                                                            });
                                                        })
                                                        .catch(error => {
                                                            Swal.showValidationMessage(
                                                              `Request failed! Please contact support.`
                                                            )
                                                        })
                             

                                                    }else{
                                                        Swal.showValidationMessage('No product selected');
                                                    }
                                                },
                                                allowOutsideClick: () => !Swal.isLoading()
                                            })

                                            
                                        }else{

                                            Swal.showValidationMessage(
                                                   `${is_validate_otp.response.message}`
                                                    //`OTP is invalid. Please check your email.`
                                                );
                                            $('#swal-input2-otp').focus();

                                        }
                                    })
                                    .catch(error => {
                                        Swal.showValidationMessage(
                                          `Request failed! Please contact support.`
                                        )
                                    })
                   
                                }else{
                                    Swal.showValidationMessage(
                                          `OTP is required. Please check your email.`
                                        );
                                    $('#swal-input2-otp').focus();
                                }

                            },
                            allowOutsideClick: () => !Swal.isLoading()
                        });

                            
                    }else{
                        this.check_system_email(orderNumber);
                    }
            
                }           
            },
            upgrade: function (orderNumber, currentRecipientEmail) {
                //alert(orderNumber);

                var recipientEmail;
                var recipientFirstname;
                var recipientLastname;
                var email = this.recipient_email;

                if(email != 'system@gifted.ph'){

                    Swal.fire({
                        //title: 'Verify Your Redemption',
                        showCancelButton: true,
                        confirmButtonText: 'Submit',
                        confirmButtonColor: '#DE3C4C',
                        showLoaderOnConfirm: true,
                        background: '#fff',
                        backdrop: 'rgb(198, 227, 222)',
                        //input: 'text',
                        html: '<h3>Verify Your Redemption</h3><p>Click on Send PIN to send a One Time PIN to your email address to confirm your redemption</p><div class="input-group mb-0">'+
                              '<div class="input-group-prepend">'+
                              '  <button id="resendOTP" data-email="'+email+'" data-source="Order #:'+this.order_number+'" class="btn btn-secondary" type="button" style="width: 130px;"><span id="btn-text">Send PIN</span> <span id="timer"></span></button>'+
                              '</div>'+
                              '<input type="text" id="swal-input2-otp" class="form-control swal2-input" placeholder="Enter PIN" style="margin: 0;">'+
                              '</div>'+
                              '<p style="margin-top: 15px;">Click <a onclick="$(\'#resendOTP\').trigger(\'click\')" href="javascript:;">here</a> to resend the PIN to your email</p>'+
                              '<div id="otp-message"></div>',
                        preConfirm: (isConfirm) => {

                            if (!isConfirm) return;

                            var otp = document.getElementById('swal-input2-otp').value;
                            if (otp != '') {
                                
                                return $.ajax({
                                    type: "POST",
                                    url: "/api/validate_otp",
                                    data: { 'email': email, 'otp': otp, 'orderNumber': this.order_number },
                                    cache: false,
                                })
                                .then(response => {

                                    //console.log(response);
                                    const is_validate_otp = JSON.parse(response);
                                    if(is_validate_otp.response.class == "success"){

                                        Swal.mixin({
                                          input: 'text',
                                          backdrop: '#c6e3de',
                                          confirmButtonText: 'Next &rarr;',
                                          showCancelButton: true,
                                          confirmButtonColor: '#DE3C4C',
                                          cancelButtonColor: '#ccc',
                                          progressSteps: ['1', '2', '3']
                                        }).queue([
                                            {
                                                title: 'Your Email Address',
                                                //inputValue : currentRecipientEmail,
                                                preConfirm: function(value)
                                                {
                                                    recipientEmail= value;
                                                    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                                                    if(value == ''){
                                                        Swal.showValidationMessage(
                                                              `Email is required.`
                                                            )
                                                    }else if (!re.test(value)){
                                                        Swal.showValidationMessage(
                                                              `Valid email required.`
                                                            )
                                                    }
                                                }
                                            },
                                            {
                                                title: 'Your First Name',
                                                preConfirm: function(value)
                                                {
                                                    recipientFirstname= value;
                                                    if(value == ''){
                                                        Swal.showValidationMessage(
                                                              `First Name is required.`
                                                            )
                                                    }
                                                }
                                            },
                                            {
                                                title: 'Your Last Name',
                                                preConfirm: function(value)
                                                {
                                                    recipientLastname= value;
                                                    if(value == ''){
                                                        Swal.showValidationMessage(
                                                              `Last Name is required.`
                                                            )
                                                    }
                                                }
                                            }
                                        ]).then((result) => {
                                          if (result.value) {
                                            const answers = JSON.stringify(result.value)
                                            Swal.fire({
                                                title: 'Recipient Details',
                                                html:
                                                    '<h4>Email: ' + recipientEmail+
                                                    '</h4><h4>First Name: ' + recipientFirstname+
                                                    '</h4><h4>Last Name: ' + recipientLastname+
                                                    '</h4>',
                                                confirmButtonColor: '#DE3C4C',
                                                confirmButtonText: 'Confirm'
                                            }).then((result) => {
                                              if (result.isConfirmed) {
                                                Swal.fire({
                                                    icon: 'warning',
                                                    title: 'Please wait!',
                                                    html: 'Validating this gift card...',
                                                    showConfirmButton: false,
                                                });

                                                $.ajax({
                                                    type: "POST",
                                                    url: "/api/ggc_to_wallet",
                                                    data: { 'orderNumber': orderNumber, 'recipientEmail': recipientEmail, 'recipientFirstname': recipientFirstname, 'recipientLastname': recipientLastname },
                                                    cache: false,
                                                })
                                                .then(response => {
                                                    console.log(response);
                                                    //return response;
                                                    const result = JSON.parse(response);

                                                    if(result.response.class == "success"){    
                                                        Swal.fire({
                                                          icon: result.response.class,
                                                          title: result.response.message,
                                                          /*
                                                          html:
                                                            'To select brands, or view your wallet balance, ' +
                                                            '<a href="/redeem/ggc-plus">here</a>.',*/
                                                          confirmButtonColor: '#DE3C4C',
                                                          confirmButtonText: 'Close'
                                                        }).then((result) => {
                                                            if (result.isConfirmed) {
                                                                location.reload();
                                                            }
                                                        });
                                                    }else{
                                                        Swal.fire({
                                                          icon: result.response.class,
                                                          title: result.response.message,
                                                          html:
                                                            'Please use alternative email address.',
                                                          showConfirmButton: false,
                                                        })
                                                    }
                                                })
                                                .catch(error => {
                                                    Swal.showValidationMessage(
                                                      `Request failed! Please contact support.`
                                                    )
                                                })
                                              }
                                            })
                                          }
                                        });

                                    }else{

                                        Swal.showValidationMessage(
                                                `${is_validate_otp.response.message}`
                                                //`OTP is invalid. Please check your email.`
                                            );
                                        $('#swal-input2-otp').focus();

                                    }
                                })
                                .catch(error => {
                                    Swal.showValidationMessage(
                                      `Request failed! Please contact support.`
                                    )
                                })
               
                            }else{
                                Swal.showValidationMessage(
                                      `OTP is required. Please check your email.`
                                    );
                                $('#swal-input2-otp').focus();
                            }

                        },
                        allowOutsideClick: () => !Swal.isLoading()
                    });

                }else{

                    Swal.mixin({
                      input: 'text',
                      backdrop: '#c6e3de',
                      confirmButtonText: 'Next &rarr;',
                      showCancelButton: true,
                      confirmButtonColor: '#DE3C4C',
                      cancelButtonColor: '#ccc',
                      progressSteps: ['1', '2', '3']
                    }).queue([
                        {
                            title: 'Your Email Address',
                            //inputValue : currentRecipientEmail,
                            preConfirm: function(value)
                            {
                                recipientEmail= value;
                                var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                                if(value == ''){
                                    Swal.showValidationMessage(
                                          `Email is required.`
                                        )
                                }else if (!re.test(value)){
                                    Swal.showValidationMessage(
                                          `Valid email required.`
                                        )
                                }
                            }
                        },
                        {
                            title: 'Your First Name',
                            preConfirm: function(value)
                            {
                                recipientFirstname= value;
                                if(value == ''){
                                    Swal.showValidationMessage(
                                          `First Name is required.`
                                        )
                                }
                            }
                        },
                        {
                            title: 'Your Last Name',
                            preConfirm: function(value)
                            {
                                recipientLastname= value;
                                if(value == ''){
                                    Swal.showValidationMessage(
                                          `Last Name is required.`
                                        )
                                }
                            }
                        }
                    ]).then((result) => {
                      if (result.value) {
                        const answers = JSON.stringify(result.value)
                        Swal.fire({
                            title: 'Recipient Details',
                            html:
                                '<h4>Email: ' + recipientEmail+
                                '</h4><h4>First Name: ' + recipientFirstname+
                                '</h4><h4>Last Name: ' + recipientLastname+
                                '</h4>',
                            confirmButtonColor: '#DE3C4C',
                            confirmButtonText: 'Confirm'
                        }).then((result) => {
                          if (result.isConfirmed) {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Please wait!',
                                html: 'Validating this gift card...',
                                showConfirmButton: false,
                            });

                            $.ajax({
                                type: "POST",
                                url: "/api/ggc_to_wallet",
                                data: { 'orderNumber': orderNumber, 'recipientEmail': recipientEmail, 'recipientFirstname': recipientFirstname, 'recipientLastname': recipientLastname },
                                cache: false,
                            })
                            .then(response => {
                                console.log(response);
                                //return response;
                                const result = JSON.parse(response);

                                if(result.response.class == "success"){    
                                    Swal.fire({
                                      icon: result.response.class,
                                      title: result.response.message,
                                      /*html:
                                        'To select brands, or view your wallet balance, ' +
                                        '<a href="/redeem/ggc-plus">here</a>.',*/
                                      confirmButtonColor: '#DE3C4C',
                                      confirmButtonText: 'Close'
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            location.reload();
                                        }
                                    });
                                }else{
                                    Swal.fire({
                                      icon: result.response.class,
                                      title: result.response.message,
                                      html:
                                        'Please use alternative email address.',
                                      showConfirmButton: false,
                                    })
                                }
                            })
                            .catch(error => {
                                Swal.showValidationMessage(
                                  `Request failed! Please contact support.`
                                )
                            })
                          }
                        })
                      }
                    });

                }

            },
            validEmail: function (email) {
              var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return re.test(email);
            }
        },
        filters: {
          moment: function (date) {
            return moment(date).format('MMMM D, YYYY h:mm:ss A');
          }
        }
    }

    $( "body" ).delegate( ".brand-option", "change", function(event) {
        var productID = $(this).val();
        productID = productID != 0 ? productID.replace('productID-','') : '';

        $( "#product-link" ).remove();
        $('.brand-option').after( "<div id='product-link' style='margin-top: 5px;'></div>" );
        
        $.ajax({
            type: "POST",
            url: "/api/product_info",
            data: {'productID': productID},
            cache: false,
        })
        .then(response => {
            //console.log(response);
            const result = JSON.parse(response);
            
            if(result.response.data != ""){
               //alert(result.response.data.slug);
               $( "#product-link" ).html('<a target="_blank" href="https://gifted.ph/'+result.response.data.slug+'">View Product</a>');
            }else{
                $( "#product-link" ).html('');
            }
        })
        .catch(error => {
            Swal.showValidationMessage(
              `Request failed! Please contact support.`
            )
        });
        
    });

</script>